import {backendUrl} from "@shared/constants/urls/appUrls";
import {fetchWithAuth} from "@shared/utils/auth";
import {getMarketPulse} from "@shared/store/MarketPulse/api/getMarketPulse";

let searchTimeout = null;
let searchController = null;

const MarketPulse = {
  namespaced: true,

  state: {

    // Состояние для маркет пульса
    currentBtcPrice: null,
    change1dUsd: null,
    data: null,

    // Состояние для поиска
    searchQuery: '',
    searchResults: [],
    searchAdd: [],

    isLoading: false,
  },

  mutations: {
    // Обновление цены биткоина
    toUpdateBtcPrice(state, btcData) {
      state.currentBtcPrice = `$${Math.floor(parseFloat(btcData.price_usd)).toLocaleString('en-US')}`;
      state.change1dUsd = parseFloat(btcData.change_1d_usd.toFixed(2));
    },
    SET_MARKET_PULSE_DATA(state, data) {
      state.data = data;
    },

    // Поиск
    setSearchQuery(state, query) {
      state.searchQuery = query;
    },
    SET_SEARCH_RESULT(state, results) {
      state.searchResults = results;
    },
    CLEAR_SEARCH_RESULTS(state) {
      state.searchResults = [];
    },

    // Добавление монеты
    SET_ADD_SUCCESS(state, coin) {
      if (!state.data || !state.data.assets) {
        state.data = {assets: []};
      }

      // Проверяем, есть ли уже монета в списке
      const existingAsset = state.data.assets.find(asset => asset.coin.api_id === coin.coin.api_id);
      if (!existingAsset) {
        state.data.assets.push(coin);
      } else {
        console.warn(`Coin with ID ${coin.coin.api_id} already exists in the list.`);
      }
    },

    // Удаление

    SET_DELETE_SUCCESS(state, id) {
      if (state.data && Array.isArray(state.data.assets)) {
        state.data.assets = state.data.assets.filter(
          asset => asset.coin.api_id !== id
        );
      }
    },
  },

  actions: {
    // Получение данных маркет пульса
    async getMarketPulse({commit}) {
      try {
        const data = await getMarketPulse();
        commit('SET_MARKET_PULSE_DATA', data);
      } catch (error) {
        console.error('Error fetching market pulse data:', error);
      }
    },

    // Поиск монет
    async searchCoins({commit}, query) {

      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      searchTimeout = setTimeout(async () => {
        if (query.length < 2) {
          commit('SET_SEARCH_RESULT', []);
          return;
        }

        if (searchController) {
          searchController.abort();
        }

        searchController = new AbortController();

        try {
          const url = `${backendUrl}/api/search/coins?q=${encodeURIComponent(query)}`;
          const response = await fetchWithAuth(url, {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            signal: searchController.signal,
          });

          const data = await response.json();
          commit('SET_SEARCH_RESULT', data.results || []);
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Search error:', err);
          }
        }
      }, 300);
    },

    // Удаление монеты
    async deleteCoin({commit}, coinId) {
      const url = `${backendUrl}/api`;
      try {
        commit('setDeleteStart');
        const response = await fetchWithAuth(`${url}/widgets/user-assets/?coin_id=${coinId}`, {
          method: 'DELETE',
        });
        if (!response.ok) {
          throw new Error(`Network error: HTTP ${response.status}`);
        } else {
          commit('SET_DELETE_SUCCESS', coinId);
        }
      } catch (error) {
        console.error('Error fetching coin search results:', error);
      }
    },

    // Добавление монеты
    async addCoins({commit}, coinId) {
      const url = `${backendUrl}/api`;
      const formData = new FormData();
      formData.append('coin_id', coinId);

      try {
        const response = await fetchWithAuth(`${url}/widgets/user-assets/`, {
          method: 'POST',
          body: formData,

        });

        const data = await response.json();
        commit('SET_ADD_SUCCESS', data);
        return data;
      } catch (error) {
        console.error('Error adding asset:', error);
        throw error;
      }
    },

    // Изменение индекса монеты
    async changeCoinIndex({commit}, {coinId, index}) {
      const url = `${backendUrl}/api/widgets/user-assets/?coin_id=${coinId}&new_index=${index}`;

      try {
        const response = await fetchWithAuth(url, {method: 'PATCH'});

        if (!response.ok) {
          throw new Error(`Network error: HTTP ${response.status}`);
        }
        return await response.json();
      } catch (error) {
        console.error('Error changing coin index:', error);
        throw error;
      }
    },

  },

  getters: {

    // Геттеры для поиска
    getSearchResults: (state) => state.searchResults,

    getMarketPulseData: (state) => state.data,

  }
}

export default MarketPulse;
